import type { DigitalInputBindingId, HudEdge } from '@sorrem/shared';
import { formatBindingLabel, labelWithKey, useInputBindings } from '@sorrem-client/ui/hooks';

/** The side label props for the `HudPanel` inside a `HudDrawer`. */
export interface HudDrawerSideLabel {
    readonly sideLabel: string;
    readonly sideLabelSide: 'left' | 'right';
}

/**
 * The side label of a panel in a drawer: its name with the key that toggles
 * it (lower-cased, as the HUD writes keys), on the side facing away from the
 * edge it slides off, so the label stays in view while it is closed.
 */
export function useHudDrawerSideLabel(edge: HudEdge, label: string, toggleBinding?: DigitalInputBindingId): HudDrawerSideLabel {
    const { bindings } = useInputBindings();
    const keyLabel = toggleBinding === undefined ? '' : formatBindingLabel(bindings, toggleBinding).toLowerCase();
    return { sideLabel: labelWithKey(label, keyLabel), sideLabelSide: edge === 'right' ? 'left' : 'right' };
}
